
import { defineComponent, ref, watch } from "vue";
import Pagination from "v-pagination-3";

export default defineComponent({
  name: "PaginationBar",
  components: { Pagination },
  props: {
    modelValue: { type: Number, default: undefined }, // optional if you want v-model, but we use v-model:page
    page: { type: Number, default: 1 },
    total: { type: Number, required: true },
    perPage: { type: Number, required: true },
  },
  emits: ["update:page", "change"],
  setup(props, { emit }) {
    const innerPage = ref(props.page);

    watch(
      () => props.page,
      (p) => (innerPage.value = p)
    );

    const emitChange = () => {
      emit("update:page", innerPage.value);
      emit("change");
    };

    return { innerPage, emitChange };
  },
});
